import { render, staticRenderFns } from "./IP2LComp.vue?vue&type=template&id=1123fcdb&"
import script from "./IP2LComp.vue?vue&type=script&lang=js&"
export * from "./IP2LComp.vue?vue&type=script&lang=js&"
import style0 from "./IP2LComp.vue?vue&type=style&index=0&id=1123fcdb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports